import React, {Component} from 'react';
import './style.css';

class CreateStudy extends Component {
    constructor(props) {
        super(props)

        this.state = {
            study_url: "",
            is_live: "",
            cpi: "",
            study_name: "",
            description: "",
        }
        this.onChange = this.onChange.bind(this);
        this.saveData = this.saveData.bind(this);

    }

    componentWillReceiveProps(props) {
        this.setState({study_name: '', study_url: '', is_live: '', cpi: '', description: ''});
    }

    onChange(e) {
        this.setState({[e.target.name]: e.target.value});
    }

    handleValidation() {
        let valid = true;

        if (this.state.study_name === "") {
            alert("Please enter study name");
            valid = false;
        } else if (this.state.study_url === "") {
            alert("Please enter study URL");
            valid = false;
        } else if (this.state.description === "") {
            alert("Please enter description");
            valid = false;
        } else if (this.state.is_live === "") {
            alert("Please select is_live");
            valid = false;
        } else if (this.state.cpi === "") {
            alert("Please enter cpi");
            valid = false;
        } else if (!this.state.cpi.match(/^\d+/)) {
            alert("Please only enter numeric characters");
            valid = false;
        }

        return valid;
    }

    saveData() {
        let studyData = {}

        if (this.handleValidation()) {
            if (this.state.study_url.includes('http')) {
                studyData.study_url = this.state.study_url;
            } else {
                studyData.study_url = ('https://' + this.state.study_url);
            }
            studyData.study_name = this.state.study_name;
            //studyData.study_url =  ('http://'+this.state.study_url);
            studyData.description = this.state.description;
            studyData.is_live = this.state.is_live;
            studyData.cpi = this.state.cpi;
            this.props.saveStudy(studyData);
        }
    }

    studyList() {
        this.props.studyList();
    }

    render() {

        let msg = "";
        if (this.props.studyMessage) {
            msg = this.props.studyMessage;
        }

        return (
            <div className="regPage">
                <div className="createnewstudy">
                    <div className="studyheader"><h1> Create New Study</h1></div>
                    <div className="setbackbutton">
                        <br/>
                        <button className="editstudybackbtn" onClick={this.studyList.bind(this)}>Back</button>
                        <br/>
                        <div className="studypage">
                            <label id="lbl1">Study Name</label>
                            <input type="text" className="textFields" placeholder="Study Name" name="study_name"
                                   value={this.state.study_name} onChange={this.onChange}/><br/>

                            <label id="lbl1">Study Description</label>
                            <input type="text" className="textFields" placeholder="Study description" name="description"
                                   value={this.state.description} onChange={this.onChange}/><br/>

                            <label id="lbl1">Study URL</label>
                            <input type="text" className="textFields" placeholder="Study URL" name="study_url"
                                   value={this.state.study_url} onChange={this.onChange}/><br/>


                            <label id="lbl2">Is Live</label>
                            <input type="radio" name="is_live" value="true" className="live"
                                   onChange={this.onChange}/> Yes
                            <input type="radio" name="is_live" value="false" className="live"
                                   onChange={this.onChange}/> No <br/><br/>


                            <label id="lbl3">CPI </label>
                            <input type="text" className="textFields" placeholder="CPI" name="cpi"
                                   value={this.state.cpi} onChange={this.onChange}/><br/>

                            <div>

                                <div className="stdbtn">
                                    <button className="studySavebtn" onClick={this.saveData}>Create</button>
                                </div>
                                <br/>
                            </div>
                            <p className="studyMSG">{msg}</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CreateStudy;


// WEBPACK FOOTER //
// ./src/components/study/index.js